import { Component, OnInit, Input, SimpleChanges, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { FolderService } from './../../services/folder.service';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';

import * as _ from 'lodash';
@Component({
	selector: 'app-bread-crumb',
	templateUrl: './bread-crumb.component.html',
	styleUrls: ['./bread-crumb.component.scss']
})
export class BreadCrumbComponent implements OnInit {
	@Input('breadCrumbData') breadData;
	@Output() updateCurrentFolder: EventEmitter<any> = new EventEmitter<any>();
	@Output() updateDisplayFiles: EventEmitter<any> = new EventEmitter<any>();
	@Output() breadCrumbPlaceHolder: EventEmitter<any> = new EventEmitter<any>();
	@Output() breadCrumbRestrictionMessage: EventEmitter<any> = new EventEmitter<any>();
	@Output() jobDocumentId: EventEmitter<any> = new EventEmitter<any>();
	navArray: any;
	folder: any;
	breadCrumbArray = [
		// {
		// 	path: "/document",
		// 	id: null,
		// 	title: "My document",
		// 	_id: null
		// }
	];
	currentIndex: any
	placeHolderName: any = "pushpraj"
	user = JSON.parse(localStorage.getItem('userRoles'))
	isView = true
	private currentBreadCrumbData: Subject<any> = new Subject<any>();

	constructor(
		public _folderService: FolderService,
		public _changes: ChangeDetectorRef,
		public _route: Router
	) {
		this._folderService.getCurrentBreadCrumbData().pipe
			(takeUntil(this.currentBreadCrumbData))
			.subscribe((data) => {
				console.log("folder::::::::: bread crumb =+>", data);
				this.currentIndex = data;
			});

	}



	ngOnDestroy() {
		this.currentBreadCrumbData.next();
		this.currentBreadCrumbData.complete();
		console.log("this breadcump DATA", this.currentBreadCrumbData.closed)
	}


	ngOnInit() {
		console.log("CURRENT URL DATA", this._route.url.includes('mydocuments'));
		if (this._route.url.includes('mydocuments')) {
			this.isView = true
			this.breadCrumbArray.push({
				path: "/document",
				id: null,
				title: "My document",
				_id: null
			})
		} else this.isView = false
		console.log("folder::::::::: bread crumb array ===+>", this.breadCrumbArray);
	}



	ngOnChanges(changes: SimpleChanges): void {
		console.log("bread ngOnchanges new Index Id ====>", changes);


		if (changes.breadData && changes.breadData.currentValue) {
			if (!this.isView) this.breadCrumbArray = []
			console.log("folder::::::::: bread crumb input ===+>", changes.breadData.currentValue, this.isView);
			let changedData: any = changes.breadData.currentValue;
			console.log(":::::: folder ", changedData, changedData.folders);
			if (changedData && changedData.folders) {

				this.folder = changedData.folders[0]

			}
			if (changedData && changedData.preFolders) {

				this.navArray = changedData.preFolders;
				console.log("what is the total nav array value", this.navArray);
				console.log("what is the breadcrumb array", this.breadCrumbArray);
				console.log("what is single folder details==========", this.folder);

				this.navArray.forEach((singleNav) => {
					if (_.findIndex(this.breadCrumbArray, (o) => { return o._id == this.folder._id; }) == -1) {
						this.breadCrumbArray.push(singleNav);

					}

				});
				// }
				console.log("navArray ========>", this.navArray);
			}
			if (this.breadCrumbArray && this.folder) {

				console.log("already esiting ======================>");
			}
			if (this.folder && _.findIndex(this.breadCrumbArray, (o) => { return o._id == this.folder._id; }) == -1) {
				this.breadCrumbArray.push(this.folder);
			}
			this._changes.detectChanges();
			console.log("folder::::::::: bread crumb array ===+>", this.breadCrumbArray);
		}
	}


	drop(event: CdkDragDrop<string[]>, title?: string) {
		console.log("FILE DROP EVENT in breadCrumb", event, title);
		if (event.container && event.container.id && title == 'folder') {
			let destinationContainerId = event.container.id.substring(4);
			console.log(" event.previousContainer.data[this.currentIndex] ", event.previousContainer.data)
			let destinationFolder = this.breadCrumbArray[destinationContainerId];
			let draggedFolder: any = event.item.data;
			console.log("bread crumb destinationContainerId ==>", destinationContainerId)
			console.log("bread crumb destinationFolder ===>", destinationFolder);
			console.log("bread crumb draggedFolder ===>", draggedFolder);

			let isDraggedInSameFolder: boolean = false;
			if (destinationFolder.child) {
				destinationFolder.child.forEach((singleChild, index) => {
					if (singleChild._id == draggedFolder._id) {
						isDraggedInSameFolder = true;
					}
				})
			}
			if (!isDraggedInSameFolder && draggedFolder.isChild) {
				this.changeFolderDestination(draggedFolder, destinationFolder);
			}
			else {
				if (event.item.data.type == 'file' && event.container.data.length - 1 != Number(destinationContainerId)) {
					let draggedFile = event.item.data;
					let obj = {
						destinationFolder: destinationFolder._id,
						sourceFolder: this.breadCrumbArray[this.breadCrumbArray.length - 1]._id,
						fileId: draggedFile._id
					}
					console.log("bread crumb Dragged in same folder but its a file =====>", obj);
					console.log("bread crumb Dragged in same folder but its a file =====>", this.breadCrumbArray);
					if (destinationContainerId != "0") {
						this.changeFileDestination(obj)
					} else {
						this.breadCrumbRestrictionMessage.emit("Cannot drag file in my document");
						console.log("bread crumb cannot move file to my document");
					}

				}
				else if (event.item.data.type == 'file' && event.container.data.length - 1 == Number(destinationContainerId)) {
					this.breadCrumbRestrictionMessage.emit("Cannot drag file in same folder");
					console.log("File dragged in same folder")
				}
				else {
					this.breadCrumbRestrictionMessage.emit("Cannot drag folder in same folder");
					console.log("bread crumb Dragged in same folder");
				}
			}
		}
	}
	/*Change folder destination*/ /*API CALL*/
	changeFolderDestination(draggedFolder, destinationFolder) {
		/*Here in new Object
			parent = Current Folder Id open in bread crumb
			folderId = The folder we dragged and moved to another folder.another
			childId = The destination folder in which folder will be moved.
		*/
		let newObject = {
			parent: draggedFolder.parent,
			folderId: draggedFolder._id,
		}
		if (destinationFolder._id) {
			newObject["childId"] = destinationFolder._id
		}
		console.log("bread crumb Dragged in another folder", newObject);
		this._folderService.changeFolderParent(newObject).subscribe((res: any) => {
			console.log("bread crumb changed successfully API CALL", res);
			this.updateCurrentFolder.emit(newObject)
		}, (err) => {
			console.log("bread crumb changed error API CALL", err);
		});

	}
	changeFileDestination(newObject) {
		this._folderService.changeFileParent(newObject).subscribe((res: any) => {
			console.log("bread crumb changed successfully API CALL", res);
			this.updateDisplayFiles.emit(newObject)
		}, (err) => {
			console.log("bread crumb changed error API CALL", err);
		});
	}

	onHoverBreadCrumb(i) {
		this.placeHolderName = this.breadCrumbArray[i].title;
		console.log("Bread placeHolderName", this.placeHolderName)
		this.breadCrumbPlaceHolder.emit(this.placeHolderName);
		this._changes.detectChanges();
	}
	onBreadCrumbLeave(i) {
		this.placeHolderName = '';
		console.log("Bread placeHolderName", this.placeHolderName)
		this.breadCrumbPlaceHolder.emit(this.placeHolderName);
		this._changes.detectChanges();
	}


	singleFolderDetails(folderId) {
		console.log("THIS IS THE FOLDER ID", folderId, this.isView);
		if (this.isView) this._route.navigate(['/mydocuments/single-folder/' + folderId])
		else {
			console.log("THIS IS FOR LABOUR");
			this.jobDocumentId.emit(folderId)
		}
		// routerLink="/mydocuments/single-folder/{{folder._id}}"
	}
}
